import type { PricingList } from 'api/types/pricing.types';
import { ReactComponent as CPIcon } from 'assets/images/cp-new-icon.svg';
import { ReactComponent as HCIcon } from 'assets/images/hc-new-icon.svg';
import { ReactComponent as PIcon } from 'assets/images/p-new-icon.svg';
import { ReactComponent as SCIcon } from 'assets/images/sc-new-icon.svg';
import { ReactComponent as WFIcon } from 'assets/images/wf-new-icon.svg';
import Button from 'components/atoms/Button';
import React from 'react';
import styled from 'styled-components';

export const BagIconMapper = new Map<PricingList.ServiceTypes, { icon: React.ReactElement }>([
  ['SHOE_CLEANING', { icon: <SCIcon /> }],
  ['CLEAN_PRESS', { icon: <CPIcon /> }],
  ['PRESS', { icon: <PIcon /> }],
  ['HOME_CARE', { icon: <HCIcon /> }],
  ['WASH_FOLD', { icon: <WFIcon /> }],
]);

export const StyledRoundButton = styled(Button)<{ isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 60px;
  background-color: #fff;
  width: 65px;
  height: 65px;
  padding: 5px;
  margin: 0px !important;
  border-color: ${({ theme, isActive }) => (isActive ? theme.colors.primary : '#fff')};
  border-width: 2px;

  &:hover,
  &:focus,
  &:active,
  &.btn-primary:not(:disabled):not(.disabled):active {
    background-color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme, isActive }) => (isActive ? theme.colors.primary : '#EDEEF2')};
    border-width: 2px;
  }
`;

export const BagInfoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
  font-weight: 300;
  font-size: 12px;
  margin-bottom: 19px;
  padding: 0px 16px;
  gap: 10px;
`;

export const StyledHeader = styled.header<{ $isnotsticky?: 'true' | 'false' }>`
  position: ${({ $isnotsticky }) => ($isnotsticky === 'true' ? 'relative' : 'sticky')} !important;
`;

export const Title = styled.p`
  margin-bottom: 0px;
`;

export const LearnMoreBtn = styled.button`
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: inherit;
  font: inherit;
  border-radius: 0;
  appearance: none; // Just in case we missed anything.
  color: ${({ theme }) => theme.text.success};
  text-decoration: underline;
`;

export const StyledBackButton = styled(Button)`
  margin-right: 8px;
  margin-top: 8px;
  border-radius: 33.333px;
  border: 0.833px solid ${({ theme }) => theme.colors.paleLightGray};
  background: ${({ theme }) => theme.colors.white};
  max-width: 50px;
  &:hover,
  &:focus,
  &:active,
  &.btn-primary:not(:disabled):not(.disabled):active {
    background-color: ${({ theme }) => theme.colors.white};
    border-width: 2px;
    border: 0.833px solid ${({ theme }) => theme.colors.paleLightGray};
  }
`;
